<template>
  <div
    :class="dimentionHandlerObj.containerClassList.value"
    @mouseenter="showControls = true"
    @mouseleave="showControls = isplaying ? false : true"
    ref="playerContainer"
    :style="{
      width: '100% !important',
      minHeight: dimentionHandlerObj.height.value + 'px !important'
    }"
  >
    <ContinuePlayComponent
      :continuefromTime="continuefromTime"
      :dur="durationObj.dur"
      :duration="duration"
      :updateWithFullVideo="updateWithFullVideo"
      :hasEnded="getHasEnded()"
    />
    <VideoErrorComponent :videoUrls="getVideoUrls()" />
    <PlayButtonComponent
      :play="play"
      :isPosterVisible="getisPosterVisible()"
      :totalDuration="durationObj.totalDurationString.value"
    />
    <PosterCaptionsComponent
      :isPosterVisible="getisPosterVisible()"
      :clickCaption="clickCaption"
      :subtitleArray="captionObj.subtitleArray"
    />
    <div
      class="pw-player-poster player-adon"
      @click="play"
      v-if="isPosterVisible"
    >
      <img :src="videoUrls.poster_url" alt="" srcset="" />
    </div>
    <div class="pw-player-controls player-adon">
      <div
        class="player-bottom-container"
        ref="playerBottomController"
        :style="{
          display: 'flex !important',
          visibility:
            (showControls && !isPosterVisible ? 'visible' : 'hidden') +
            ' !important'
        }"
      >
        <SeekbarComponent
          :durationString="durationObj.durationString"
          :seekbarCss="seekbarObj.seekbarCss"
          :totalDurationString="durationObj.totalDurationString"
          :play="play"
          :pause="pause"
          :currentTime="durationObj.currentTime"
          :dur="durationObj.dur"
          :video="getVideo()"
        />
        <div class="flex-box">
          <ControlsLeftComponent
            :playbtnString="getPlayButtonStringRef()"
            :togglePlay="togglePlay"
            :mediaElm="getVideo()"
            :IS_IOS="IS_IOS"
          />
          <div style="flex-grow: 1 !important"></div>
          <ControlsRightComponent
            :canUseCaptions="getcanUseCaptions()"
            :playerContainer="getplayerContainer()"
            :captionBtnString="captionObj.captionBtnString"
            :IS_IOS="IS_IOS"
            :clickCaption="clickCaption"
            :subtitleArray="captionObj.subtitleArray"
            :currentCaptions="captionObj.currentCaptions"
            :height="dimentionHandlerObj.height"
          />
        </div>
      </div>
      <CaptionsComponent
        :captionData="captionObj.currentCaptionData"
        :currentTime="durationObj.currentTime"
        v-if="canUseCaptions"
      />
    </div>
    <div class="pw-player-container" ref="shaka_container">
      <video
        ref="video"
        preload="metadata"
        class="pw-video"
        :poster="videoUrls.poster_url"
        crossorigin
        @click="isplaying ? pause() : play()"
      >
        <track
          v-for="(track, i) in subtitlesForIos"
          :key="i"
          :src="track.web_vtt_url"
          :label="getLanguageString(track.language)"
          kind="subtitles"
          :srclang="getLanguageString(track.language)"
          :default="i == 0 ? true : false"
          crossorigin
        />
      </video>
    </div>
  </div>
</template>

<script lang="ts">
//always import shaka.css first [coz it has default values rest of them overwrite when needed]
import "@/assets/video/shaka.css"
import "@/assets/video/player-poster.css"
import "@/assets/video/shaka-play-button.css"
import "@/assets/video/seek-bar.css"
import "@/assets/volume_slider.css"
import "@/assets/video/continue-play.css"
import { SubtitleUrls } from "@/models/captions/SubtitleUrls"
import { VideoInfo } from "@/models/VideoInfo"
import { computed, defineComponent, PropType, ref } from "vue"
import setUpShaka from "@/composables/shaka-player/load-shaka"
import injectStrict from "@/utils/injectStrict"
import { EventBusKey, GlobalDataKey, LoggerKey } from "@/symbols"
import { isIOS } from "@/services/deviceDetection"
import isVideoUrlsValid from "@/utils/VIdeoUrlsValudator"
import setUpDuration from "@/composables/shared/duration-handler"
import { StringToSeconds } from "@/services/DurationFormatter"
import { setUpPlayBtn } from "@/composables/shared/play-button-handler"
import setUpSeekBar from "@/composables/shared/seekbar-handler"
import mergeSubtitles from "@/services/mergeSubtitles"
import { AwEventType } from "@/models/AwEventType"
import { container } from "tsyringe"
import { AnalyticsClient } from "@/services/AnalyticsService"
import { VideoType } from "@/models/VideoType"
import SetUpCaptionService from "@/composables/captions-handler"
import { getLanguageString } from "@/utils/getLanguageString"
import setUpDinemtionHandler from "@/composables/shared/dimention-handler"
//Components
import CaptionsComponent from "@/components/VideoPlayerComponents/CaptionsComponent.vue"
import ContinuePlayComponent from "@/components/VideoPlayerComponents/ContinuePlayComponent.vue"
import VideoErrorComponent from "@/components/VideoPlayerComponents/VideoErrorComponent.vue"
import PlayButtonComponent from "@/components/VideoPlayerComponents/PlayButtonComponent.vue"
import PosterCaptionsComponent from "@/components/VideoPlayerComponents/PosterCaptionsComponent.vue"
import SeekbarComponent from "@/components/VideoPlayerComponents/SeekbarComponent.vue"
import ControlsLeftComponent from "@/components/VideoPlayerComponents/ControlsLeftComponent.vue"
import ControlsRightComponent from "@/components/VideoPlayerComponents/ControlsRightComponent.vue"
export default defineComponent({
  components: {
    CaptionsComponent,
    ContinuePlayComponent,
    VideoErrorComponent,
    PlayButtonComponent,
    PosterCaptionsComponent,
    SeekbarComponent,
    ControlsLeftComponent,
    ControlsRightComponent
  },
  props: {
    video_urls: { type: Object as PropType<VideoInfo>, required: true },
    duration: String,
    subtitleUrls: Object as PropType<SubtitleUrls>,
    subtitles: Array as PropType<Array<SubtitleUrls>>,
    isgated: { type: Boolean, default: false, required: false },
    mid: { type: Number, required: false },
    videoType: { type: String, required: true },
    continuefromTime: { type: Number, default: 0, required: false }
  },
  setup(props) {
    const IS_IOS = isIOS(navigator.platform, navigator.maxTouchPoints)
    let captionBtn = ref<HTMLElement>()
    let playerBottomController = ref<HTMLElement>()
    let playerContainer = ref<HTMLElement>()
    let videoUrls = ref(props.video_urls)
    let getVideoUrls = () => videoUrls
    let logger = injectStrict(LoggerKey)
    var showControls = ref(true)
    var enterframeTimeout = 0
    const globalData = injectStrict(GlobalDataKey)
    const video = ref<HTMLVideoElement>()
    let shakaSeeker = ref<HTMLInputElement>()
    const isPosterVisible = ref(true)
    let getisPosterVisible = () => isPosterVisible
    let durationObj = setUpDuration(StringToSeconds(props.duration))
    const captionObj = SetUpCaptionService(
      mergeSubtitles(props.subtitleUrls, props.subtitles)
    )
    let shakaSetUpObj = setUpShaka(video, globalData.value)
    let hasEnded = ref(false)
    let { isplaying, playbtnString, getPlayButtonStringRef } =
      setUpPlayBtn(hasEnded)
    let seekbarObj = setUpSeekBar(durationObj.currentTime, durationObj.dur)
    var subtitlesForIos = computed(() =>
      IS_IOS ? captionObj.subtitleArray.value : []
    )
    const captionDropDownHeight = computed(() =>
      captionObj.subtitleArray.value.length > 2
        ? 3 * 27 + 40
        : (captionObj.subtitleArray.value.length + 1) * 27 + 40
    )
    let eventbus = injectStrict(EventBusKey)
    let startTime = ref(0)
    let analytics = container.resolve(AnalyticsClient)
    let startRange = parseFloat(globalData.value.time_data.startTime ?? "0")
    let endRange = parseFloat(globalData.value.time_data.endTime ?? "Infinity")

    const video_type = computed(() =>
      durationObj.dur.value == StringToSeconds(props.duration)
        ? props.videoType
        : VideoType.Webinar
    )
    let getHasEnded = () => hasEnded
    let canUseCaptions = computed(
      () => captionObj.subtitleArray.value.length > 0 && !IS_IOS
    )
    let getVideo = () => video
    let getcanUseCaptions = () => canUseCaptions
    let getplayerContainer = () => playerContainer
    let dimentionHandlerObj = setUpDinemtionHandler(playerContainer)

    return {
      dimentionHandlerObj,
      getplayerContainer,
      getcanUseCaptions,
      getVideo,
      getPlayButtonStringRef,
      getLanguageString,
      IS_IOS,
      canUseCaptions,
      getisPosterVisible,
      getVideoUrls,
      getHasEnded,
      durationObj,
      seekbarObj,
      captionObj,
      hasEnded,
      endRange,
      startRange,
      captionBtn,
      analytics,
      startTime,
      eventbus,
      globalData,
      subtitlesForIos,
      captionDropDownHeight,
      showControls,
      video,
      playerBottomController,
      shakaSetUpObj,
      isPosterVisible,
      shakaSeeker,
      isplaying,
      playbtnString,
      enterframeTimeout,
      playerContainer,
      videoUrls,
      video_type,
      logger
    }
  },
  async mounted() {
    if (!isVideoUrlsValid(this.videoUrls, this.logger)) return
    await this.loadPlayer()
    this.globalData.videoPlayers.push(this.video!)
    var self = this
    this.video!.onplay = function () {
      self.startTime = self.video!.currentTime
      self.isplaying = true
      self.hasEnded = false
      self.isPosterVisible = false
    }
    this.video!.onpause = function () {
      self.isplaying = false
      self.showControls = true
      clearTimeout(self.enterframeTimeout)
      self.registerAnalytics()
    }
    this.video!.onended = function () {
      self.redirect()
      self.hasEnded = true
      clearTimeout(self.enterframeTimeout)
    }
    this.dimentionHandlerObj.handleResize()
    window.addEventListener("resize", this.dimentionHandlerObj.handleResize)
    if (this.globalData.autoPlay) this.play()
  },
  methods: {
    async loadPlayer() {
      if (this.IS_IOS) {
        await this.shakaSetUpObj.loadhls(this.videoUrls.hls_url)
      } else {
        await this.shakaSetUpObj.loaddash(this.videoUrls.dash_url)
      }
    },
    togglePlay() {
      this.isplaying ? this.pause() : this.play()
    },
    play() {
      if (this.isgated) {
        this.eventbus.emit("gate-event")
        return
      }
      this.eventbus.emit("playing-Video", this.mid)
      this.video?.play()
      this.globalData.videoPlayers.forEach(video => {
        if (this.video !== video) {
          video.pause()
        }
      })
      this.enterframe()
    },
    pause() {
      this.video?.pause()
    },
    enterframe() {
      clearTimeout(this.enterframeTimeout)
      if (!this.video) return
      if (this.video.currentTime < this.startRange) {
        this.video.currentTime = this.startRange
      }
      if (this.video.currentTime > this.endRange) {
        this.pause()
        this.video.currentTime = this.startRange
      }
      this.durationObj.currentTime.value =
        this.video.currentTime - this.startRange
      try {
        this.seekbarObj.totalBufferedTime.value =
          (this.video?.buffered.end(0) ?? 0) - this.video.currentTime
      } catch (e) {} //log error

      this.enterframeTimeout = setTimeout(this.enterframe, 200)
    },
    clickCaption(cap: string, play: boolean = false) {
      if (!this.IS_IOS) this.captionObj.setCaption(cap)
      if (play) this.play()
    },
    redirect() {
      if (this.globalData.redirect_data.url)
        window.location.href = this.globalData.redirect_data.url
    },
    async updateWithFullVideo() {
      if (!this.globalData.fullVideoInfo.isReady || !this.continuefromTime)
        return
      this.captionObj.updateCaptionsArray(
        this.globalData.fullVideoInfo.subtitles
      )
      this.videoUrls = this.globalData.fullVideoInfo.video_urls as VideoInfo
      await this.shakaSetUpObj.detachShakaPlayer()
      await this.loadPlayer()
      this.video!.currentTime = this.continuefromTime
      this.durationObj.dur.value = this.video!.duration
      this.play()
    },
    registerAnalytics() {
      var event = {
        eventType: AwEventType.VideoPlayed,
        momentId:
          this.durationObj.dur.value == StringToSeconds(this.duration)
            ? this.mid
            : undefined,
        start: Math.floor(this.startTime),
        end: Math.ceil(this.video!.currentTime),
        videoType: this.video_type
      }
      this.analytics.register(event)
    }
  }
})
</script>
